module.exports = __webpack_public_path__ + "img/bb2.e14334bd.jpg";